/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-07 17:30:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-03-13 18:42:26
 * @FilePath: /lobby/src/common/vant.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import {
  Toast,
  Dialog,
  Form,
  Field,
  CellGroup,
  Swipe,
  SwipeItem,
  Popup,
  Sticky,
  Popover,
  ActionSheet,
  Notify,
  Calendar,
  Locale,
  Cell,
  List,
  Tab,
  Overlay,
  Barrage,
  Loading,
  Grid,
  GridItem
} from 'vant'
import enUS from 'vant/es/locale/lang/en-US'

const components = [
  Toast,
  Dialog,
  Form,
  Field,
  CellGroup,
  Swipe,
  SwipeItem,
  Popup,
  Sticky,
  Popover,
  ActionSheet,
  Notify,
  Calendar,
  Locale,
  Cell,
  List,
  Tab,
  Overlay,
  Barrage,
  Loading,
  Grid,
  GridItem
]
export const VantResolve = {
  install(app) {
    // 设置语言为英语
    Locale.use('en-US', enUS)
    components.forEach((component) => {
      app.use(component)
    })
  }
}
